export const APP_STORE_CTA_EVENT = 'app_store_cta_clicked';
export const APP_STORE_CTA_EVENT_LABEL = 'App Store CTA clicked';

export function trackAppStoreCtaClick(location) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', APP_STORE_CTA_EVENT, {
    event_category: 'engagement',
    event_label: APP_STORE_CTA_EVENT_LABEL,
    cta_location: location,
  });
}
